<template>
    <div
        id="drop_zone"
        class="drag w-full"
        :class="(dragging ? 'bg-gray-200 ' : ' ') + dropzoneClass">
        <div
            class="flex items-center"
            @drop.prevent="emits('dropFiles', $event)"
            @dragenter.prevent="draggingLocal = true"
            @dragover.prevent="draggingLocal = true"
            @dragleave.prevent="draggingLocal = false">
            <Icon
                :name="uploadIcon"
                :class="'h-8 w-8 mr-4 ' + uploadIconClass" />
            <div class="flex flex-col text-sm leading-6 text-gray-600 dark:text-gray-300">
                <div class="flex">
                    <label
                        :for="(inputId === '') ? 'file-upload' : inputId"
                        class="relative cursor-pointer rounded-md bg-transparent dark:bg-gray-700 font-semibold focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-600 focus-within:ring-offset-2 dark:ring-offset-gray-700"
                        :class="{
                            'text-neutral-500 dark:text-neutral-500': disabled,
                            'text-primary-600 dark:text-primary hover:text-primary-500': !disabled,
                        }">
                        <span>{{ $t('files.upload') }}</span>
                        <input
                            :id="(inputId === '') ? 'file-upload' : inputId"
                            :name="(inputId === '') ? 'file-upload' : inputId"
                            type="file"
                            :disabled="disabled"
                            :accept="accept"
                            class="sr-only"
                            :multiple="multiple"
                            @change="emits('inputFiles', $event)">
                    </label>
                    <p class="pl-1">
                        {{ $t('files.orDragAndDrop') }}
                    </p>
                </div>
                <div class="text-xs text-gray-400">
                    max. 10 MB
                </div>
                <div
                    v-if="acceptedFormatsLabel"
                    class="mt-2">
                    <div
                        class="inline-flex justify-center items-center gap-1 mt-0.5 text-xs font-medium text-gray-500 bg-gray-100 rounded px-1.5 py-0.5 w-fit">
                        <Icon
                            name="heroicons:document-check"
                            class="h-3.5 w-3.5 shrink-0" />
                        {{ acceptedFormatsLabel }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    inputId: {
        type: String,
        default: ''
    },
    dragging: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    uploadIcon: {
        type: String,
        default: 'heroicons:camera'
    },
    accept: {
        type: String,
        default: ''
    },
    multiple: {
        type: Boolean,
        default: false
    },
    uploadIconClass: {
        type: String,
        default: ''
    },
    dropzoneClass: {
        type: String,
        default: ''
    },
    acceptedFormatsLabel: {
        type: String,
        default: ''
    }
})

const emits = defineEmits(['inputFiles', 'dropFiles', 'update:dragging'])


const draggingLocal = computed({
    get: () => props.dragging,
    set: (value) => emits('update:dragging', value)
})
</script>